import { EnvConfig } from './env-config.interface'

const envConfig: { [Key in keyof EnvConfig]: EnvConfig[Key] } = {
  TZ: process.env.TZ! ?? process.env.NEXT_PUBLIC_TZ,
  PUBLIC_CACHE_TTL: process.env.PUBLIC_CACHE_TTL ?? '',
  API_HOST: process.env.REACT_APP_API_HOST ?? 'localhost',
  API_PORT: process.env.REACT_APP_API_PORT ?? '8000',
  API_PROTOCOL: process.env.REACT_APP_API_PROTOCOL ?? 'http',
  API_URL: process.env.REACT_APP_API_URL ?? 'http://0.0.0.0:8000/api',
  API_VERSION: process.env.REACT_APP_API_VERSION ?? 'v1',
}

export function env<K extends keyof EnvConfig>(key: K, defaultValue: EnvConfig[K] | null = null): EnvConfig[K] {
  return envConfig[key] ?? (defaultValue as EnvConfig[K])
}
